import React from "react";
import DashboardLayout from "@cloudpremise/portal_core/src/themes/mui/examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "@cloudpremise/portal_core/src/themes/mui/examples/Navbars/DashboardNavbar";
import { useAuthProvider, loginRequest, Loader } from "@cloudpremise/portal_core";
import { useNavigate } from "react-router-dom";
import MDBox from "@cloudpremise/portal_core/src/themes/mui/components/MDBox";
import Card from "@mui/material/Card";
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { useMsal } from "@azure/msal-react";

// @mui material components
import Grid from "@mui/material/Grid";

const LoginWithMicrosoft = (props) => {
    const [ authorized, authType ] = useAuthProvider();
    const { instance, inProgress } = useMsal();
    const navigate = useNavigate();
    React.useEffect(() => {
        if(authorized && authType === "microsoft"){
            return navigate("/home", { replace: true });
        }
        if(inProgress !== "none"){
            return;
        }
        localStorage.removeItem("reactforce_logout");
        localStorage.setItem("microsoft_login", "1");
        instance.loginRedirect(loginRequest).catch(e => {
            console.log(e);
        });
    });
    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox my={3}>
                <Grid container justifyContent="center" alignItems="center">
                    <Grid item xs={12} md={7} lg={5} py={{ xs: 0, sm: 2 }} ml="auto" mr="auto" position="relative">
                        <MDBox component="form" role="form">
                            <Card style={{borderRadius: "xs"}}>
                                <MDBox
                                    variant="contained"
                                    bgColor="transparent"
                                    borderRadius="sm"
                                    coloredShadow="none"
                                    p={2}
                                    textAlign="left"
                                >
                                    <Loader color="info" />
                                </MDBox>
                            </Card>
                        </MDBox>
                    </Grid>
                </Grid>
            </MDBox>
        </DashboardLayout>
    )
};

export default LoginWithMicrosoft;